<form [class]="request.type" [formGroup]="paymentForm" (ngSubmit)="onPay()">
  <div class="amount-image-row">
    <app-adjustable-amount formControlName="amount" [amountInCents]="request.amount" [amountLimit]="request.amountLimit" [isAdjustable]="request.isAdjustable"> </app-adjustable-amount>
    @if (request.imageUrl) {
      <div class="payment-request-image-container">
        <input type="checkbox" id="zoomCheck" />
        <label for="zoomCheck">
          <img
            [ngSrc]="request.imageUrl!"
          placeholder="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCIgdmlld0JveD0iMCAwIDUwIDUwIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjREREREREIi8+PHBhdGggZmlsbD0iIzAwMDAwMCIgZD0iTTE3LjE3IDI1LjAwNXEwLS4zOS4xNC0uNzQuMTUtLjM1LjQtLjZ0LjYtLjRxLjM1LS4xNS43NS0uMTV0Ljc0LjE1cS4zNC4xNS42LjQuMjYuMjUuNDEuNi4xNS4zNS4xNS43NCAwIC40LS4xNS43NC0uMTUuMzUtLjQxLjZ0LS42LjM5cS0uMzQuMTUtLjc0LjE1LS40IDAtLjc1LS4xNS0uMzUtLjE0LS42LS4zOXQtLjQtLjZxLS4xNC0uMzQtLjE0LS43NFptNS45NCAwcTAtLjM5LjE0LS43NHQuMzktLjZxLjI1LS4yNS42LS40LjM1LS4xNS43NS0uMTV0Ljc1LjE1cS4zNC4xNS42LjQuMjUuMjUuNC42LjE1LjM1LjE1Ljc0IDAgLjQtLjE1Ljc0LS4xNS4zNS0uNC42LS4yNi4yNS0uNi4zOS0uMzUuMTUtLjc1LjE1dC0uNzUtLjE1cS0uMzUtLjE0LS42LS4zOXQtLjM5LS42cS0uMTQtLjM0LS4xNC0uNzRabTUuOTMgMHEwLS4zOS4xNS0uNzQuMTQtLjM1LjM5LS42dC42LS40cS4zNS0uMTUuNzUtLjE1dC43NS4xNXEuMzQuMTUuNi40LjI1LjI1LjQuNi4xNS4zNS4xNS43NCAwIC40LS4xNS43NC0uMTUuMzUtLjQuNi0uMjYuMjUtLjYuMzktLjM1LjE1LS43NS4xNXQtLjc1LS4xNXEtLjM1LS4xNC0uNi0uMzl0LS4zOS0uNnEtLjE1LS4zNC0uMTUtLjc0WiIvPjwvc3ZnPg=="
          [placeholderConfig]="{ blur: true }"
            priority
            class="payment-request-image"
            width="70"
            height="70"
            alt="payment request image"
            />
          <img ngSrc="assets/images/zoom.svg" class="zoom-image" width="33" height="33" alt="payment request image" />
        </label>
      </div>
    }
  </div>
  <div>
    <button [disabled]="this.disablePayButton" class="submit-payment" type="submit">Betaal {{ request.requestorName }}</button>
  </div>
</form>
